import barn from "./farm-avatars/barn.png";
import chicken from "./farm-avatars/chicken.png";
import duck from "./farm-avatars/duck.png";
import goat from "./farm-avatars/goat.png";
import pig from "./farm-avatars/pig.png";
import rabbit from "./farm-avatars/rabbit.png";
import sheep from "./farm-avatars/sheep.png";

export const FARM_AVATAR_ASSETS = Object.freeze({
  goat,
  chicken,
  pig,
  sheep,
  duck,
  rabbit,
  barn,
});

export const FARM_AVATAR_TYPES = Object.freeze(Object.keys(FARM_AVATAR_ASSETS));

export const FARM_AVATAR_ANIMAL_POOL = Object.freeze([
  "goat",
  "chicken",
  "pig",
  "sheep",
  "duck",
  "rabbit",
]);

export const FARM_AVATAR_COLORS = Object.freeze([
  { id: "sage", className: "mfp-avatar-sage" },
  { id: "blue", className: "mfp-avatar-blue" },
  { id: "peach", className: "mfp-avatar-peach" },
  { id: "rose", className: "mfp-avatar-rose" },
  { id: "gold", className: "mfp-avatar-gold" },
  { id: "lilac", className: "mfp-avatar-lilac" },
  { id: "mint", className: "mfp-avatar-mint" },
  { id: "cream", className: "mfp-avatar-cream" },
]);
